import { render, staticRenderFns } from "./ClassifiedResume.vue?vue&type=template&id=09cbfea4&scoped=true"
import script from "./ClassifiedResume.vue?vue&type=script&lang=js"
export * from "./ClassifiedResume.vue?vue&type=script&lang=js"
import style0 from "./ClassifiedResume.vue?vue&type=style&index=0&id=09cbfea4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cbfea4",
  null
  
)

export default component.exports